import React from 'react';
import { NavLink } from 'react-router-dom';

const FooterOne = () => {
    return (
        <footer className=" bg-light-700 footer py-80"> 
            <div className="container container-lg">
                <div className="footer-item-two-wrapper d-flex align-items-start flex-wrap">
                 
                    {/* About Us Section */} 
                    <div className="footer-item">
                        <h6 className="footer-item__title text-gray-100">About us</h6>
                        <ul className="footer-menu">
                            <li className="mb-16 flex-align gap-16">
                                <span className="w-24 h-24 flex-center text-md" style={{ color: '#ff6000' }}>
                                    <i className="ph-fill ph-buildings" />
                                </span>
                                <NavLink to="/compony-profile" className="text-gray-200" style={{ transition: 'color 0.3s' }} onMouseEnter={(e) => e.currentTarget.style.color = '#ff6000'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>
                                    Company Profile
                                </NavLink>
                            </li>
                            <li className="mb-16 flex-align gap-16">
                                <span className="w-24 h-24 flex-center text-md" style={{ color: '#ff6000' }}>
                                    <i className="ph-fill ph-storefront" />
                                </span>
                                <NavLink to="/marchant-center" className="text-gray-200" style={{ transition: 'color 0.3s' }} onMouseEnter={(e) => e.currentTarget.style.color = '#ff6000'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>
                                    Merchant Center
                                </NavLink>
                            </li>
                            
                            <li className="mb-16 flex-align gap-16">
                                <span className="w-24 h-24 flex-center text-md" style={{ color: '#ff6000' }}>
                                    <i className="ph-fill ph-file-text" />
                                </span>
                                <NavLink to="/term-conditions" className="text-gray-200" style={{ transition: 'color 0.3s' }} onMouseEnter={(e) => e.currentTarget.style.color = '#ff6000'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>
                                    Rules &amp; Policy
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                   
                    {/* Information Section */}
                    <div className="footer-item">
                        <h6 className="footer-item__title text-gray-100">Information</h6>
                        <ul className="footer-menu">
                            <li className="mb-16 flex-align gap-16">
                                <span className="w-24 h-24 flex-center text-md" style={{ color: '#ff6000' }}>
                                    <i className="ph-fill ph-handshake" />
                                </span>
                                <NavLink to="/become-seller" className="text-gray-200" style={{ transition: 'color 0.3s' }} onMouseEnter={(e) => e.currentTarget.style.color = '#ff6000'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>
                                    Become a Vendor
                                </NavLink>
                            </li>
                            <li className="mb-16 flex-align gap-16">
                                <span className="w-24 h-24 flex-center text-md" style={{ color: '#ff6000' }}>
                                    <i className="ph-fill ph-truck" />
                                </span>
                                <NavLink to="/our-suppliers" className="text-gray-200" style={{ transition: 'color 0.3s' }} onMouseEnter={(e) => e.currentTarget.style.color = '#ff6000'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>
                                    Our Suppliers
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    {/* Did You Know Section */}
                    <div className="footer-item">
                        <h6 className="text-gray-100">Did you Know ?</h6>
                        <p className="mb-16 text-gray-200">Blink Buy Dropshipping has become the leading platform</p>
                        <ul className="flex-align gap-16"> 
                            <NavLink to="/">
                                {" "}
                                 <img  
                                    src={`${process.env.PUBLIC_URL}/assets/images/logo/blinkBuyWhiteLog.png`}                           alt='Logo'
                                    style={{ width: '180px', height: 'auto' }} // Adjust width as needed
                                /> 
                            </NavLink>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default FooterOne;